





































































import {
  Component,
  Vue
} from "vue-property-decorator";
import { Getter } from 'vuex-class';
import { premium } from '@/types'

@Component
export default class Premium extends Vue {
  @Getter public isPremium: boolean;
  @Getter public isSuccess: boolean;

  buyPremium(isPremium: premium) {
    if(isPremium) {
      this.$store.commit('showErrorAlert', 'You are already Premium user!')
      setTimeout(() => {
        this.$store.commit('hideErrorAlert')
      }, 2000);
      return;
    }
    this.$store.dispatch("updatePremium", isPremium)
  }

  switchToFree(isPremium: premium) {
    if(!isPremium) {
      this.$store.commit('showErrorAlert', 'You are already free user!')
      setTimeout(() => {
        this.$store.commit('hideErrorAlert')
      }, 2000);
      return;
    }
    this.$store.dispatch("updatePremium", isPremium)
  }
}
